<h6 style="text-align:left">Earning</h6>

<div style="display: block; width:450px">
  <canvas baseChart [labels]="pieChartLabels" [data]="pieChartData" [chartType]="pieChartType"
    (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)" [colors]="colors"></canvas>
</div>
